module.exports = __webpack_public_path__ + "img/is_1(1).6cfad717.png";